import { z } from 'zod';

import { Option } from '../../types/Option';

const DCPortConfigurations = ['unipolar', 'bipolar'] as const;

type DCPortConfiguration = (typeof DCPortConfigurations)[number];

const options = [
    { value: 'unipolar', label: 'Unipolar' },
    { value: 'bipolar', label: 'Bipolar' },
] as Option<DCPortConfiguration>[];

const validator = z.enum(DCPortConfigurations).nullable().default(null);

export const DCPortConfiguration = {
    validator,
    options,
};
